import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { actionCreators } from '../../actions';
import { trackEvent } from 'dibs-tracking';

import ArrowLeft from 'dibs-vg/dist/react/arrow-left';
import ArrowRight from 'dibs-vg/dist/react/arrow-right';
import MessageBannerItem from './MessageBannerItem';

import style from './MessageBanner-style.scss';

import { isPreview, wasShown, getTrackingObj, setValuesToStorage, addToShownList } from './messageHelpers';

class MessageBannerCarousel extends Component {
    constructor(props) {
        super(props);

        this.state = {
            curr: 0
        };

        this.handlePrevious = this.handlePrevious.bind(this);
        this.handleNext = this.handleNext.bind(this);
        this.fireTracking = this.fireTracking.bind(this);
    }

    componentDidMount() {
        this.props.setMessages(this.props.messages);
    }

    handlePrevious() {
        let index = this.state.curr - 1;

        if (index < 0) {
            index = this.props.messages.length - 1;
        }

        this.fireTracking(this.state.curr, 'previous', index);
        this.setState({ curr: index });
    }

    handleNext() {
        let index = this.state.curr + 1;

        if (index > this.props.messages.length - 1) {
            index = 0;
        }

        this.fireTracking(this.state.curr, 'next', index);
        this.setState({ curr: index });
    }

    fireTracking(previous, type, current) {
        if (!isPreview()) {

            trackEvent(
                getTrackingObj({
                    messageItem: this.props.messages[previous],
                    action: `banner ${type} clicked`
                })
            );
        }
        this.setItemValuesToStorage(this.props.messages[current]);
    }

    setItemValuesToStorage(messageItem) {

        if (!isPreview() && !wasShown(messageItem)) {
            setValuesToStorage(messageItem);
            addToShownList(messageItem);

            trackEvent(
                getTrackingObj({
                    messageItem,
                    action: 'banner displayed'
                })
            );
        }
    }

    render() {
        const { messages } = this.props;
        const { curr } = this.state;
        const count = messages.length;
        const hasPagination = count && count > 1;

        const carouselItemsStyle = {
            width: `${count * 100}%`,
            transform: `translateX(${-((curr) / count) * 100}%)`
        };

        const wrapperClasses = classnames({
            [style.carouselWrapper]: true,
            [style.hasPagination]: hasPagination
        });

        this.setItemValuesToStorage(messages[0]);

        return (
            <div className={wrapperClasses}>
                { hasPagination ?
                    <div className={style.carouselArrowWrapperLeft} onClick={this.handlePrevious}>
                        <ArrowLeft className={style.carouselArrowLeft}/>
                    </div>
                : null }
                <div className={style.carousel}>
                    <div className={style.carouselItems} style={carouselItemsStyle}>
                        {messages.map((item) => <MessageBannerItem key={item.note.serviceId} messageItem={item} />)}
                    </div>
                </div>
                { hasPagination ?
                    <div className={style.carouselArrowWrapperRight} onClick={this.handleNext}>
                        <ArrowRight className={style.carouselArrowRight}/>
                    </div>
                : null }
            </div>
        );
    }
}

MessageBannerCarousel.propTypes = {
    messages: PropTypes.array,
    setMessages: PropTypes.func
};

const mapDispatchToProps = (dispatch) => {

    return {
        setMessages: (messages) => {
            dispatch(actionCreators.setBannerMessages(messages));
        }
    };
};

export default connect(null, mapDispatchToProps)(MessageBannerCarousel);



// WEBPACK FOOTER //
// ./src/components/MessageBanner/MessageBannerCarousel.jsx